"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.post = void 0;
const logger_1 = require("@sundaysky/logger");
const httpClient_1 = __importDefault(require("./httpClient"));
const log = (0, logger_1.logger)("dtclient");
const DTAAS_RETRY_OPTIONS = {
    limit: 2, // total is +1 since it doesn't count initial run
    baseDelay: 100,
    timeout: httpClient_1.default.DEFAULT_TIMEOUT
};
const post = (postdata, passthoughHeaders, dtaasEndpoint) => __awaiter(void 0, void 0, void 0, function* () {
    log.info("Posting to ", dtaasEndpoint);
    log.info(postdata);
    try {
        const response = yield httpClient_1.default.postWithRetries(dtaasEndpoint, postdata, passthoughHeaders, DTAAS_RETRY_OPTIONS, log.info.bind(log));
        log.info(`DT service returns with status ${response.statusCode}`);
        return response.body;
    }
    catch (err) {
        log.error(`Decision Table Service Error: ${err === null || err === void 0 ? void 0 : err.message}`);
        throw new Error(`Decision Table Service Error: ${err}`);
    }
});
exports.post = post;
//# sourceMappingURL=dtclient.js.map